import React from 'react';
import markdownContent from '!!raw-loader!static/facebook_privacy.md';
import { Markdown } from 'Common';

export const ExternalFacebookPrivacyPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};

export default ExternalFacebookPrivacyPage;
